import React from 'react'
import ReactDOM from 'react-dom'
import { consumeSsoToken } from 'pestel/auth/sso'

const rootElement = document.getElementById('root')

// RegulApp hands users off with `#sso=<regul token>` in the URL fragment.
// Exchange it for a PESTEL JWT *before* pulling in `root` — that import creates
// the Redux store, and the auth reducer seeds `authToken` from localStorage at
// module-evaluation time, so a token written afterwards would be ignored until
// the next reload. `consumeSsoToken` resolves immediately when there is no
// hand-off, which is the common case.
consumeSsoToken()
  .then(() => import('root'))
  .then(({ default: Root }) => {
    ReactDOM.render(<Root />, rootElement)

    if (module.hot && process.env.NODE_ENV === 'development') {
      module.hot.accept('./root', () => {
        const NextRoot = require('./root').default
        ReactDOM.render(<NextRoot />, rootElement)
      })
    }
  })
